// pages/Conference.js
import React, { useEffect } from 'react';
import Carousel from '../components/Carousel';
function ConferenceENG() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="conference-page" >

    <div style={{
      padding: '80px 0 40px',
      textAlign: 'center',
      backgroundImage: 'url(/images/cover.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      width: '100%',
      marginLeft: 'calc(-50vw + 50%)',
      minHeight: '400px'
    }}>
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 1
      }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px' }}>

      <style jsx>{`
        @media (max-width: 768px) {
          .conference-page > div:first-child {
            padding: 60px 0 30px !important;
            min-height: 300px !important;
          }
          .conference-page h1 {
            font-size: 2.5rem !important;
          }
          .conference-page h3 {
            font-size: 1.4rem !important;
          }
        }
      `}</style>
      <img
        src="/images/Asset5.png"
        alt="Conference Icon"
        style={{
          width: '80px',
          height: '80px',
          objectFit: 'contain'
        }}
      />
      <h1 style={{
        fontSize: '3.5rem',
        marginBottom: '20px',
        background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        direction: 'ltr'
      }}>
        SYMPOSIUM
      </h1>

      <h3 style={{
        fontSize: '2rem',
        marginBottom: '20px',
        fontWeight: '600',
        lineHeight: '1.6',
        direction: 'ltr'
      }}>
        Technology-facilitated violence against women and girls
        <br />
        <span style={{ color: 'var(--primary-orange)', fontSize: '1.8rem' }}>
          A silent digital pandemic
        </span>
      </h3>
      <div style={{
        background: 'var(--secondary-black)',
        padding: '20px 30px',
        borderRadius: '15px',
        borderRight: '4px solid var(--primary-orange)',
        marginBottom: '25px',
        direction: 'ltr'
      }}>
        <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
        <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>Date:</strong> Wednesday, November 26, 2025
        </p>
        <p style={{ fontSize: '1.3rem' }}>
          <img src="/images/time.png" className="tab-icon3-img" /> <strong>Time:</strong> Starting at 5:30 PM
        </p>
      </div>
      </div>
    </div>

      {/* Conference Section */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">



          {/* Statistics Section */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Alarming statistics
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  60%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  of women in the Arab region experience digital violence
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  1.5M
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  Moroccan women are affected by digital violence every year
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  44%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  of digital violence cases spill into real life
                </p>
              </div>

              <div style={{
                background: 'var(--primary-black)',
                padding: '30px',
                borderRadius: '15px',
                textAlign: 'center',
                border: '2px solid var(--primary-orange)',
                transition: 'transform 0.3s ease',
                direction: 'ltr'
              }}>
                <div style={{
                  fontSize: '3.5rem',
                  fontWeight: '700',
                  color: 'var(--primary-orange)',
                  marginBottom: '10px'
                }}>
                  11%
                </div>
                <p style={{ fontSize: '1.1rem', lineHeight: '1.6' }}>
                  of victims report digital violence
                </p>
              </div>
            </div>

            <div style={{
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '35px',
              borderRadius: '15px',
              border: '2px solid rgba(255, 107, 53, 0.3)',
              textAlign: 'center',
              direction: 'ltr'
            }}>
              <p style={{ fontSize: '1.2rem', lineHeight: '1.9', color: 'var(--text-light)' }}>
              These numbers are only the tip of the iceberg. With most violence going unreported, the true extent of digital violence against women and girls remains far greater.
              </p>
            </div>
          </div>

          <div className="section-separator"></div>

          {/* Symposium Focus Points */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Symposium objectives
            </h3>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              textAlign:'center'
            }}>
              {[
                {
                  icon: '🛡️',
                  title: 'Protection and mobilization',
                  desc: 'Strengthening the protection of women\'s and girls\' rights in the digital space and the age of AI'
                },
                {
                  icon: '📚',
                  title: 'Education and knowledge',
                  desc: 'Highlighting rights-violating technological practices and promoting measures to prevent them'
                },
                {
                  icon: '🔔',
                  title: 'Awareness and reporting',
                  desc: 'Promoting digital safety and encouraging victims to report incidents of digital violence'
                },
                {
                  icon: '⚖️',
                  title: 'Accountability',
                  desc: 'Emphasizing the responsibility of major online platforms in combating digital violence'
                },
                {
                  icon: '🔊',
                  title: 'Breaking the silence',
                  desc: 'Promoting reporting mechanisms and encouraging victims to speak up'
                }
              ].map((item, index) => (
                <div key={index} style={{
                  background: 'var(--primary-black)',
                  padding: '25px',
                  borderRadius: '15px',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  transition: 'all 0.3s ease',
                  direction: 'ltr'
                }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '15px' }}>{item.icon}</div>
                  <h4 style={{ fontSize: '1.4rem', marginBottom: '12px', color: 'var(--primary-orange)' }}>
                    {item.title}
                  </h4>
                  <p style={{ fontSize: '1.05rem', lineHeight: '1.7', color: 'var(--text-light)' }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Conference Program */}
          <div style={{ marginBottom: '50px', direction: 'ltr' }}>
            <h3 style={{
              fontSize: '2.3rem',
              marginBottom: '35px',
              textAlign: 'center',
              color: 'var(--white)',
              direction: 'ltr'
            }}>
              Program
            </h3>

            <div style={{
              background: 'var(--primary-black)',
              padding: '35px',
              borderRadius: '15px',
              border: '2px solid var(--primary-orange)',
                textAlign:'left'
            }}>
              {[
                { time: '5:00–5:30 PM', event: 'Tea Break', type: 'welcome' },
                { time: '5:30–5:45 PM', event: 'Address by Ms. Amina Bouayach, Chairperson of the National Human Rights Council (CNDH)', type: 'opening' },
                { time: '5:45–6:00 PM', event: 'Address by Ms. Naima Ben Yahia, Minister of Solidarity, Social Inclusion, and Family', type: 'opening' },
                { time: '6:15–6:30 PM', event: 'Address by Mr. Chakib Benmoussa, High Commissioner for Planning', type: 'opening' },
                { time: '6:30–6:45 PM', event: 'Address by Ms. Myriem Ouchen Noussairi, UN Women Representative in Morocco', type: 'opening' },
                { time: '6:45–7:00 PM', event: 'Intervention by Ms. Nahla Haidar, Chairperson of the UN Committee on the Elimination of Discrimination Against Women (CEDAW)', type: 'keynote' },
                { time: '7:00–7:30 PM', event: 'Discussion', type: 'panel' },
                { time: '7:30–8:00 PM', event: 'Launch of the CNDH\'s Campaign (16 Days / 12 Regions)', type: 'ceremony' }
              ].map((item, index) => (
                <div key={index} style={{
                  padding: '20px',
                  borderBottom: index < 7 ? '1px solid rgba(255, 107, 53, 0.2)' : 'none',
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '20px'
                }}>
                  <div style={{
                    background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
                    padding: '10px 20px',
                    borderRadius: '10px',
                    fontWeight: '700',
                    fontSize: '1.1rem',
                    minWidth: '140px',
                    textAlign: 'center'
                  }}>
                    {item.time}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                      {item.event}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div style={{
              marginTop: '30px',
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(255, 133, 85, 0.05))',
              padding: '25px',
              borderRadius: '15px',
              textAlign: 'center',
              direction: 'ltr'
            }}>
              <h4 style={{ fontSize: '1.4rem', marginBottom: '15px', color: 'var(--primary-orange)' }}>
                Participants
              </h4>
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--text-light)' }}>
                Parliament • Ministry of Justice • Ministry of Higher Education, Scientific Research and Innovation • Economic, Social and Environmental Council (CESE)
                <br />
                High Authority for Audiovisual Communication (HACA) • General Directorate of National Security (DGSN)
                <br />
                National Control Commission for the Protection of Personal Data • Delegation of the European Union to Morocco
                <br />
                Civil Society Organizations • Journalists and media professionals
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Mapping Show Section */}
      <div style={{ background: 'var(--primary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">
          <div className="section-separator" style={{ margin: '0 0 60px 0' }}></div>

          <div className="container" style={{ padding: '80px 20px 40px', textAlign: 'center', direction: 'ltr' }}>
            <img
              src="/images/Asset6.png"
              alt="Conference Icon"
              style={{
                width: '80px',
                height: '80px',
                objectFit: 'contain'
              }}
            />
            <h1 style={{
              fontSize: '3.5rem',
              marginBottom: '20px',
              background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              direction: 'ltr'
            }}>
            Mapping show
            </h1>
            <p style={{
              fontSize: '1.3rem',
              lineHeight: '1.9',
              marginBottom: '25px',
              color: 'var(--text-light)',
              direction: 'ltr'
            }}>
              A creative visual and artistic experience using video mapping to transform the façade of the National Human Rights Council headquarters into a living canvas that tells the stories of women and girls affected by digital violence.
            </p>
            <div style={{
              background: 'var(--secondary-black)',
              padding: '20px 30px',
              borderRadius: '15px',
              borderRight: '4px solid var(--primary-orange)',
              marginBottom: '25px',
              direction: 'ltr'
            }}>
              <p style={{ fontSize: '1.3rem', marginBottom: '10px' }}>
                  <img src="/images/calandarv.png" className="tab-icon3-img" /> <strong>Official launch date:</strong> Wednesday, November 26, 2025
              </p>
              <p style={{ fontSize: '1.3rem' }}>
                <img src="/images/time.png" className="tab-icon3-img" /> <strong>Time:</strong> Daily starting at 7:30 PM
              </p>
            </div>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '40px',
            alignItems: 'center'
          }}>



          </div>




          <div className="section-separator"></div>

                <div style={{ textAlign: 'center', marginTop: '50px', direction: 'ltr' }}>
                  <h3 style={{
                    fontSize: '2.5rem',
                    marginBottom: '25px',
                    color: 'var(--white)',
                    direction: 'ltr'
                  }}>
              Be part of the change
                  </h3>

                  <p style={{
                    fontSize: '1.2rem',
                    marginTop: '30px',
                    color: 'var(--text-light)',
                    fontStyle: 'italic',
                    direction: 'ltr'
                  }}>
                Together we break the silence | Together we stand against the silent digital pandemic
                  </p>
                </div>
        </div>
      </div>

  <Carousel />
    </div>
  );
}

export default ConferenceENG;
